/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { RegionResponse } from "../../../core/models/partners/RegionResponse";
import { request as __request } from "../../helpers/api/request";
import type { CityResponse } from "../../models/partners/CityResponse";
import type { PartnerResponse } from "../../models/partners/PartnerResponse";
import type { PartnerResponsePageResponse } from "../../models/partners/PartnerResponsePageResponse";

export class PartnersService {
  /**
   * @param id
   * @returns PartnerResponse Success
   * @throws ApiError
   */
  public static async getById(id: number): Promise<PartnerResponse> {
    const result = await __request({
      method: "GET",
      path: `/partners/${id}`,
    });
    return result.body;
  }

  /**
   * @param pageSize
   * @param pageNum
   * @param sort
   * @returns PartnerResponsePageResponse Success
   * @throws ApiError
   */
  public static async get(pageSize?: number, pageNum?: number, sort?: string | null): Promise<PartnerResponsePageResponse> {
    const result = await __request({
      method: "GET",
      path: `/partners`,
      query: {
        PageSize: pageSize,
        PageNum: pageNum,
        Sort: sort,
      },
    });
    return result.body;
  }

  /**
   * @returns PartnerResponse Success
   * @throws ApiError
   */
  public static async getAll(): Promise<Array<PartnerResponse>> {
    const result = await __request({
      method: "GET",
      path: `/partners/all`,
    });
    return result.body;
  }

  /**
   * @param id
   * @returns number Success
   * @throws ApiError
   */
  public static async getProjectsCount(id: number): Promise<number> {
    const result = await __request({
      method: "GET",
      path: `/partners/${id}/projects/count`,
    });
    return result.body;
  }

  /**
   * @param partners
   * @param regions
   * @param cities
   * @param targetGroups
   * @param baseSystems
   * @param from
   * @param to
   * @returns PartnerResponse Success
   * @throws ApiError
   */
  public static async getFiltered(
    partners?: Array<number> | null,
    regions?: Array<number> | null,
    cities?: Array<number> | null,
    targetGroups?: Array<string> | null,
    baseSystems?: Array<number> | null,
    from?: string | null,
    to?: string | null
  ): Promise<Array<PartnerResponse>> {
    const result = await __request({
      method: "GET",
      path: `/partners/filtered`,
      query: {
        Partners: partners,
        Regions: regions,
        Cities: cities,
        TargetGroups: targetGroups,
        BaseSystems: baseSystems,
        From: from,
        To: to,
      },
    });
    return result.body;
  }

  /**
   * @returns RegionResponse Success
   * @throws ApiError
   */
  public static async getRegions(): Promise<Array<RegionResponse>> {
    const result = await __request({
      method: "GET",
      path: `/partners/regions`,
    });
    return result.body;
  }

  /**
   * @returns CityResponse Success
   * @throws ApiError
   */
  public static async getCities(): Promise<Array<CityResponse>> {
    const result = await __request({
      method: "GET",
      path: `/partners/cities`,
    });
    return result.body;
  }
}
